import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { EMPTY, Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime, distinctUntilChanged, map, switchMap } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { AddressCounty } from "../../../../core/models/shared/countyList";
import { AddressState } from "../../../../core/models/shared/stateList";
import { District } from "../../../../core/models/shared/districtList";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { City } from "../../../../core/models/shared/cityList";
import { Address } from "../../../../core/models/shared/address";
import { GetAllVendorsDto } from "../../../../core/models/vendor/getAllVendors";
import { SamplePOSummaryDto } from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { AddressService } from "../../../../core/services/address.service";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { MelissaAddressResponseDto } from "../../../../core/models/shared/mellssaAddressResponseDto";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { MelissaAddressFormatResponseDto } from "../../../../core/models/shared/melissaAddressFromatResponseDto";
import { Popover, PopoverModule } from "primeng/popover";
import { ScrollerModule } from "primeng/scroller";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from "primeng/autocomplete";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";

@UntilDestroy()
@Component({
  selector: "jni-samplepo-ship-to-address",
  templateUrl: "./samplepo-ship-to-address.component.html",
  styleUrls: ["./samplepo-ship-to-address.component.scss"],
  providers: [ConfirmationService],
  imports: [
    SelectModule,
    ReactiveFormsModule,
    TableModule,
    CommonModule,
    PopoverModule,
    ScrollerModule,
    CommonModule,
    AutoCompleteModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class SamplepoShipToAddressComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() districtList: District[] = [];
  @Input() countyList: AddressCounty[] = [];
  @Input() stateList: AddressState[] = [];
  @Input() addressFieldStatus!: boolean;
  @Input() isPrimaryFieldStatus = true;
  @Input() countryRegionSelectedId = "USA";
  @Input() parent!: FormGroup;
  @Input() formgroupName!: string;
  @Input() hiddenHeadingStatus = false;
  @Input() appartmentFieldStatus = false;
  @Input() countryRegionList: AddressCountryRegion[] = [];
  @Input() cityList: City[] = [];
  @Input() brandingConsultantObject!: GetBCForSalesOrderDto;
  @Input() customerBillToObject?: ClientSearchList;
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Input() shiftToAddressField = "";
  @Input() vendorAccountSeletion = "";
  @Input() addressBookName = "";
  @Input() formErrors!: Record<string, string>;
  @Input() validationMessages!: Record<string, Record<string, string>>;
  @Input() addressField!: {
    deliveryAddressfield: string;
    countryRegionfield: string;
    addressFormatField: string;
    addressLine2Field: string;
    addressLine3Field: string;
    cityD365Field: string;
    stateD365Field: string;
    zipCodeD365Field: string;
    streetD365Field: string;
    attentionInformationD365Field: string;
    locationD365Field: string;
    addressD365Field: string;
    isPrimaryD365Field: string;
    validateAddressField: string;
    shipToEmail: string;
  };
  @Input() showAddress = true;
  @Input() collapseStatus!: boolean;
  @Input() showName = true;
  @Input() editHeaderStatus = false;
  @Input() samplePOSummary: SamplePOSummaryDto = {} as SamplePOSummaryDto;
  @Output() validationErrorEvent = new EventEmitter();

  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  shipToAddress = false;
  @Input() attentionFieldStatus!: boolean;

  vendorAccountAndBook = false;
  showSmallLoader = false;
  nonUsandCadFieldStatus = true;
  isAddressError = false;
  addressValidationStatus = true;
  isOpen = false;
  hideValidateButton = true;
  hideNonUsAddressSaveButton = true;

  shiftToAddressList: Address[] = [];

  addressBookList: Address[] = [];

  vendorList: GetAllVendorsDto[] = [];

  formatResponse!: MelissaAddressFormatResponseDto;
  appartmentList: string[] = [];
  stateSelectedId = "";
  zipSelectionCode = "";
  melissaSelection = "";
  selectedAppartment = "";
  address2 = "";
  address3 = "";
  city = "";
  state = "";
  postalcode = "";
  originalAddress = "";

  public searchVendor$ = new Subject<string>();
  public melissa!: string;
  public melissaForNonUsAddress1!: string;
  @ViewChild("shipAddressPopover") shipAddressPopover?: Popover;
  @ViewChild("shipToInput", { read: ElementRef })
  shipToInput?: ElementRef<HTMLInputElement>;
  private popoverOpen = false;
  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _addressService: AddressService,
    private _addNewClientService: AddNewClientService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.searchVendorName();
    this.parent.get(["addressInformation", "addressD365"])?.disable();
  }

  ngAfterViewInit() {
    document.addEventListener("mousedown", this.onDocumentClick);
  }

  ngOnDestroy() {
    document.removeEventListener("mousedown", this.onDocumentClick);
  }

  onDocumentClick = (event: MouseEvent) => {
    if (!this.popoverOpen) return;
    const inputElem = this.shipToInput?.nativeElement;
    if (inputElem?.contains(event.target as Node)) {
      return;
    }
    const popoverElem = document.querySelector(".pop2");
    if (popoverElem?.contains(event.target as Node)) {
      return;
    }
    this.shipAddressPopover?.hide();
    this.popoverOpen = false;
  };

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  onDeliveryAddressChange(event: SelectChangeEvent, shipaddress: Popover) {
    this.showName = true;

    this.parent.patchValue({
      [this.formgroupName]: {
        [this.addressField.attentionInformationD365Field]: "",
      },
    });

    this.parent.patchValue({
      addressInformation: {
        deliveryNameD365: "",
      },
    });

    this.parent.get(["addressInformation", "addressD365"])?.disable();
    if (event.value === "Customer Bill To" || event.value === "Bill To") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.attentionFieldStatus = false;
      this.patchAddressOfCustomerBillTo();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.disableDeliveryName();
      //this.disableClientBillingDetails();
      this.patchClientBillingDetails();
    } else if (event.value === "Customer Address Book") {
      this.showName = false;
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.attentionFieldStatus = false;
      this.patchAddressOfCustomerAddressBook(shipaddress, event);
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.disableDeliveryName();
    } else if (event.value === "Vendor") {
      this.showName = false;
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.attentionFieldStatus = false;
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.disableDeliveryName();
    } else if (event.value === "Branding Consultant") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.attentionFieldStatus = true;
      this.patchBrandingConsultantName();
      this.patchAddressOfBrandingConsultant();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.disableDeliveryName();
    } else {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = true;
      this.showValidateAddress = true;
      this.showAddress = false;
      this.attentionFieldStatus = false;
      this.parent.get(["addressInformation", "addressD365"])?.enable();
      this.enableDeliveryName();
      this.applyValidationOnAddress();
      if (event.value !== "One Time") {
        this.clearShifToForm();
      }
      if (event.value === "One Time") {
        this.clearValidationOnAddress();
      }
    }
    //this.enableCountryField(event);
  }

  attentionStatus(status: boolean) {
    this.attentionFieldStatus = status;
  }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.vendorList = res.data as unknown as GetAllVendorsDto[];
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  clearValidationOnAddress() {
    this.parent.get(["addressInformation", "addressD365"])?.clearValidators();
    this.parent
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  applyValidationOnAddress() {
    this.parent
      .get(["addressInformation", "addressD365"])
      ?.setValidators(Validators.required);
    this.parent
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  hiddenAddressFields() {
    this.showDistrict = false;
    this.showPostBox = false;
    this.showCity = false;
    this.showCounty = false;
    this.showState = false;
    this.showStreetNumber = false;
    this.showbuildingComplement = false;
    this.showAddressBook = false;
    this.showAppartment = false;
  }

  clearShifToForm() {
    this.parent.patchValue({
      addressInformation: {
        // countryRegionIdD365: '',
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  clearAllShifToForm() {
    this.parent.patchValue({
      addressInformation: {
        deliveryAddressDescription: "",
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  patchAddressOfCustomerBillTo() {
    this.showSmallLoader = true;
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              const primaryAddress = res.data.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" ||
                  x.isPrimaryD365?.toLowerCase() === "1"
              );
              if (primaryAddress.length > 0) {
                this.patchFormInShipToAddressField(primaryAddress[0]);
                this.parent.patchValue({
                  addressInformation: {
                    deliveryNameD365: this.customerBillToObject?.name,
                  },
                });
              }
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  patchClientBillingDetails() {
    if (this.customerBillToObject?.clientAccount) {
      this.showSmallLoader = true;

      this._addNewClientService
        .getClientBillingDetails(this.customerBillToObject.clientAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = true;
            this.parent.patchValue({
              [this.formgroupName]: {
                [this.addressField.attentionInformationD365Field]:
                  res.data.billingAttentionD365 || "",
                [this.addressField.locationD365Field]:
                  res.data.billingLocationD365 || "",
              },
            });
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  patchAddressOfCustomerAddressBook(
    shipaddress: Popover,
    event: SelectChangeEvent
  ) {
    this.showSmallLoader = true;
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.shiftToAddressList = res.data;
              shipaddress.show(event);
              //this.patchFormInShipToAddressField(res.data[0]);
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  patchBrandingConsultantName() {
    this.patchValueInDeliveryName("Nadel");
    if (this.brandingConsultantObject?.projectName) {
      this.patchValueInAttention(
        this.brandingConsultantObject.projectName || ""
      );
    } else if (this.samplePOSummary?.brandingConsultantName) {
      this.patchValueInAttention(
        this.samplePOSummary.brandingConsultantName || ""
      );
    }
  }

  patchAddressOfBrandingConsultant() {
    this.showSmallLoader = true;
    const partyNumber = this.brandingConsultantObject?.partyNumber;
    const projectId = this.samplePOSummary.brandingConsultant;
    if (partyNumber != undefined && partyNumber != "") {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(partyNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.patchFormInShipToAddressField(res.data[0]);
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    } else if (projectId != undefined && projectId != "") {
      this._samplepoListingService
        .getBCForProject(projectId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<GetUserProjectDto>) => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.brandingConsultantObject = res.data;
              this.patchAddressOfBrandingConsultant();
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
    this.showSmallLoader = false;
  }

  onShitToAddressSeletion(event: Address, shipAddressToggle: Popover) {
    shipAddressToggle.hide();
    if (event.descriptionD365 != "") {
      this.shiftToAddressField = event.descriptionD365 ?? "";
      this.parent.patchValue({
        addressInformation: {
          deliveryNameD365: event.descriptionD365,
        },
      });
    }
    this.patchFormInShipToAddressField(event);
  }

  patchFormInShipToAddressField(address: Address) {
    if (address) {
      this.parent.patchValue({
        addressInformation: {
          countryRegionIdD365: address.countryRegionIdD365,
          zipCodeD365: address.zipCodeD365,
          streetD365: address.streetD365,
          cityD365: address.cityD365,
          stateD365: address.stateD365,
          countyD365: address.countyD365,
          streetNumberD365: address.streetNumberD365,
          buildingComplimentD365: address.buildingComplimentD365,
          apartment_RUD365: address.apartment_RUD365,
          postBoxD365: address.postBoxD365,
          districtNameD365: address.districtNameD365,
          addressLocationNumberD365: parseInt(
            address.locationNumberD365 ?? "0"
          ),
          addressD365: address?.addressD365?.replace("<br/>", "\n"),
        },
      });
    }
  }

  // enableCountryField(event: any) {
  //   if (event === "One Time" || event === "One Time Blank") {
  //     this.parent.get(["addressInformation", "countryRegionIdD365"])?.enable();
  //     this.parent.get(["addressInformation", "streetD365"])?.enable();
  //   } else {
  //     this.parent.get(["addressInformation", "countryRegionIdD365"])?.disable();
  //     this.parent.get(["addressInformation", "streetD365"])?.disable();
  //   }
  // }

  onshipToAddressFilter(event: MouseEvent, drop: Popover) {
    drop.show(event.target as HTMLElement);
    this.popoverOpen = true;
  }

  onVendorSearchOpenToggle(mydrop: Popover, event: Event, target: HTMLElement) {
    mydrop.show(event, target);
  }

  disableClientBillingDetails() {
    this.parent
      .get([
        this.formgroupName,
        this.addressField.attentionInformationD365Field,
      ])
      ?.disable();
    this.parent
      .get([this.formgroupName, this.addressField.locationD365Field])
      ?.disable();
  }

  onVendorAccountSelection(event: GetAllVendorsDto, vendorAccount: Popover) {
    this.clearShifToForm();
    this.vendorAccountSeletion = event.vendorName ?? "";
    const partyNumber = event.partyNumber;
    if (event.vendorName) {
      this.addressBookName = event.vendorName;
      this.parent.patchValue({
        addressInformation: {
          deliveryNameD365: event.vendorName,
        },
      });
    }
    if (
      this.vendorAccountSeletion != undefined &&
      this.vendorAccountSeletion != ""
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(partyNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data != null) {
              this.addressBookList = res.data;
              if (this.addressBookList.length === 1) {
                this.onVendorAddressBookSelection(
                  this.addressBookList[0],
                  vendorAccount
                );
              }
              if (this.addressBookList?.length > 1) {
                vendorAccount.hide();
              } else {
                vendorAccount.hide();
              }
            }
          },
        });
    }
    vendorAccount.hide();
  }

  onVendorAddressBookSelect(event: MouseEvent, drop: Popover) {
    if (this.addressBookList?.length > 1) {
      drop.show(event);
    } else {
      drop.hide();
    }
  }

  showAddressComponent() {
    const deliveryAddress: string = this.parent.get([
      "addressInformation",
      "deliveryAddressDescription",
    ])?.value;
    if (deliveryAddress?.toLowerCase().includes("one")) {
      this.parent.get(["addressInformation", "addressD365"])?.enable();
      this.showAddress = false;
      return true;
    } else {
      this.parent.get(["addressInformation", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  enableDeliveryName() {
    this.parent.get(["addressInformation", "deliveryNameD365"])?.enable();
  }
  disableDeliveryName() {
    this.parent.get(["addressInformation", "deliveryNameD365"])?.disable();
  }

  onVendorAddressBookSelection(
    event: Address,
    vendorAddressBookToggle: Popover
  ) {
    // this.addressBookName = event.addressD365;
    this.parent.patchValue({
      addressInformation: {
        countryRegionIdD365: event.countryRegionIdD365,
        zipCodeD365: event.zipCodeD365,
        streetD365: event.streetD365,
        cityD365: event.cityD365,
        stateD365: event.stateD365,
        countyD365: event.countyD365,
        streetNumberD365: event.streetNumberD365,
        buildingComplimentD365: event.buildingComplimentD365,
        apartment_RUD365: event.apartment_RUD365,
        postBoxD365: event.postBoxD365,
        districtNameD365: event.districtNameD365,
        addressLocationNumber: parseInt(event.locationNumberD365 ?? ""),
        addressD365: event.addressD365?.replace("<br/>", "\n"),
      },
    });
    vendorAddressBookToggle?.hide();
  }

  ngOnChanges(): void {
    const countryRegion = this.countryRegionSelectedId;
    if (countryRegion && countryRegion !== "USA") {
      this.clearZipCodeValidations();
    }
    if (this.editHeaderStatus) {
      this.onCountryRegionSelection(countryRegion);
    }
  }

  clearZipCodeValidations() {
    this.parent.get(["shipTo", "zipCodeD365"])?.clearValidators();
    this.parent.get(["shipTo", "zipCodeD365"])?.updateValueAndValidity();
  }

  onCountryRegionSelection(countryid: string) {
    if (countryid) {
      this.parent.get([this.formgroupName, "zipCodeD365"])?.enable();
      this.parent.get([this.formgroupName, "districtNameD365"])?.enable();
      this.parent.get([this.formgroupName, "cityD365"])?.enable();
      this.parent.get([this.formgroupName, "countyD365"])?.enable();
      this.parent.get([this.formgroupName, "stateD365"])?.enable();
    } else {
      this.parent.get([this.formgroupName, "zipCodeD365"])?.disable();
      this.parent.get([this.formgroupName, "districtNameD365"])?.disable();
      this.parent.get([this.formgroupName, "cityD365"])?.disable();
      this.parent.get([this.formgroupName, "countyD365"])?.disable();
      this.parent.get([this.formgroupName, "stateD365"])?.disable();
    }

    if (countryid) {
      if (
        countryid?.toLowerCase() === "usa" ||
        countryid?.toLowerCase() === "can"
      ) {
        this.nonUsandCadFieldStatus = true;
        //this.showAddress = false;
      } else {
        this.nonUsandCadFieldStatus = false;
        //this.showAddress = true;
        this.clearNonUsForm();
      }
    }
  }

  getCountyListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCountyList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countyList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  removeAddressField() {
    this.parent.patchValue({
      [this.formgroupName]: {
        addressD365: "",
      },
    });
    this.melissaSelection = "";
    this.selectedAppartment = "";
  }

  patchValueInMelissaAddressKey() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  selectedStreet(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();
    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (
            (formatResponse.Results as string)?.toLowerCase()?.includes("av")
          ) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMelissaAddressKey();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }

    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        // streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: `${item.Address.Address1}\n${item.Address.Address2}\n${
          item.Address.Address3
        }${this.selectedAppartment || ""}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }

    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });

    setTimeout(() => {
      if (!item.Address.SubBuilding) {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressFormat: "",
          },
        });
      }
    }, 1);
  }

  patchAddress(item: MelissaAddressFormatResponseDto) {
    if (!item.PostalCode) {
      return;
    }
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Locality,
        stateD365: item.AdministrativeArea,
        streetD365: item.PremisesNumber + " " + item.Thoroughfare,
        zipCodeD365: item.PostalCode,
        districtNameD365: item.SubAdministrativeArea,
        postBoxD365: item.PostBox,
        countyD365: item.SubAdministrativeArea,
        // streetNumberD365: item.PremisesNumber,
        buildingComplimentD365: item.SubPremises,
        addressD365: `${item.AddressLine1}\n${item.AddressLine2}\n${item.AddressLine3}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  melissaSearchResult: MelissaAddressResponseDto[] = [];

  searchMelissaAutoComplete(event: AutoCompleteCompleteEvent) {
    if (event.query === "") {
      this.melissaSearchResult = [] as MelissaAddressResponseDto[];
    } else {
      try {
        this._addressService
          .getMelissaData(event.query, this.countryRegionSelectedId)
          .then((x: MelissaAddressResponseDto[]) => {
            this.melissaSearchResult = x;
          });
      } catch {
        this.melissaSearchResult = [] as MelissaAddressResponseDto[];
      }
    }
  }

  melissaFormatter(result: MelissaAddressResponseDto) {
    return result?.Address?.Address;
  }

  onStateSelectionChange(stateid: string) {
    this.parent.patchValue({ [this.formgroupName]: { cityD365: "" } });
    this.getCityListData(stateid, this.countryRegionSelectedId);
  }

  getCityListData(stateid: string, countryid: string) {
    this.showSmallLoader = true;
    this._addressService
      .getCityList(stateid, countryid)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.cityList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  formattedAddressChange() {
    const formattedAddress = this.parent.get([
      this.formgroupName,
      "addressD365",
    ])?.value;
    if (this.melissaSelection != formattedAddress) {
      this.hideValidateButton = false;
      this.setValidationForAddress();
    } else {
      this.hideValidateButton = true;
      this.removeValidationForAddress();
    }
  }

  setValidationForAddress() {
    // this.parent.setErrors({ invalid: true });
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.setValidators(Validators.required);
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  removeValidationForAddress() {
    // this.parent.setErrors({ invalid: false });
    this.parent.get([this.formgroupName, "validateAddress"])?.clearValidators();
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  confirm() {
    this.confirmationService.confirm({
      message: "Are you sure that you want to update address?",
      accept: () => {
        this.validateAddress();
      },
      reject: () => {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressD365: this.melissaSelection,
          },
        });
        this.validateAddress();
      },
    });
  }

  validateAddress(isTypedAddress = false) {
    this.showSmallLoader = true;
    if (isTypedAddress) {
      this.appartmentList = [];
      this.selectedAppartment = "";
    }
    const address = this.parent.get([this.formgroupName, "addressD365"])?.value;

    const country = this.countryRegionSelectedId;

    this._addressService
      .checkAddressValidation(address, country)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const item = res[0];
          this.formatResponse = item;
          if (item) {
            this.patchAddress(item);
          }
          this.showSmallLoader = false;
          if (item) {
            if ((item.Results as string).toLowerCase().includes("av")) {
              this.addressValidationStatus = false;
              this.hideValidateButton = true;
              this.removeValidationForAddress();
              this.isAddressError = false;
            } else {
              this.setValidationForAddress();
              this.hideValidateButton = false;
              this.isAddressError = true;
            }
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this.isAddressError = true;
        },
      });
  }

  onAppartmentSelection(event: SelectChangeEvent) {
    // this.ngselect.close();
    // const formattedAddress = this.parent.get([
    //   this.formgroupName,
    //   "addressD365",
    // ])?.value;

    if (typeof event.value === "string") {
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: event.value || "",
          addressD365: `${this.melissaSelection}${event.value || ""}`,
          addressFormat: "",
        },
      });
    } else {
      event.value = "";
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: event || "",
          addressD365: `${this.melissaSelection}${event || ""}`,
          addressFormat: "",
        },
      });
    }

    this.validateAddress();
    this.appartmentFieldStatus = true;
  }

  enableAndDisabledValidateButton() {
    const cityD365 = this.parent.get([this.formgroupName, "cityD365"])?.value;
    const stateD365 = this.parent.get([this.formgroupName, "stateD365"])?.value;
    const zipCodeD365 = this.parent.get([
      this.formgroupName,
      "zipCodeD365",
    ])?.value;

    if (cityD365 && stateD365 && zipCodeD365) {
      this.hideNonUsAddressSaveButton = false;
    } else {
      this.hideNonUsAddressSaveButton = true;
      this.clearAddress();
    }
  }

  clearAddress() {
    this.parent.patchValue({
      shipTo: {
        streetD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });
  }

  clearNonUsForm() {
    this.parent.patchValue({
      shipTo: {
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
      },
    });
  }

  melissaNonUsSearchResult: MelissaAddressResponseDto[] = [];

  melissaFormatterNonUs(result: MelissaAddressResponseDto) {
    return result?.Address?.Address;
  }

  searchMelissaNonUsAutoComplete(event: AutoCompleteCompleteEvent) {
    if (event.query === "") {
      this.melissaNonUsSearchResult = [] as MelissaAddressResponseDto[];
    } else {
      try {
        this._addressService
          .getMelissaGlobalData(
            event.query,
            this.countryRegionSelectedId,
            this.city,
            this.state,
            this.address2,
            this.address3,
            this.postalcode
          )
          .then((x: MelissaAddressResponseDto[]) => {
            this.melissaNonUsSearchResult = x;
          });
      } catch {
        this.melissaNonUsSearchResult = [] as MelissaAddressResponseDto[];
      }
    }
  }

  getMelissaGlobalData(term: string): void {
    if (!term || term.trim() === "") {
      this.melissaNonUsSearchResult = [];
      return;
    }

    this._addressService
      .getMelissaData(term, this.countryRegionSelectedId)
      .then((data: MelissaAddressResponseDto[]) => {
        this.melissaNonUsSearchResult = data;
      })
      .catch(() => {
        this.melissaNonUsSearchResult = [];
      });
  }

  patchValueInMak() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  patchValueInDeliveryName(name: string) {
    this.parent.patchValue({
      addressInformation: {
        deliveryNameD365: name,
      },
    });
  }

  patchValueInAttention(name: string) {
    this.parent.patchValue({
      [this.formgroupName]: {
        [this.addressField.attentionInformationD365Field]: name,
      },
    });
  }

  selectedStreetForNonUs(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();

    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (
            (formatResponse.Results as string)?.toLowerCase()?.includes("av")
          ) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMak();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;

    this.parent.patchValue({
      [this.formgroupName]: {
        addressLine1: item.Address.Address1,
        addressLine2: item.Address.Address2,
        addressLine3: item.Address.Address3,
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        // streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: `${item.Address.Address1}\n${item.Address.Address2}\n${
          item.Address.Address3
        }${this.selectedAppartment || ""}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });
  }
}
